import clsx from 'clsx';
import React from 'react';

interface DataParamAction {
  title: string;
  icon: string;
  onClick: (e) => void;
}

const PanelBlockAction = (props: DataParamAction) => {
  return (
    <button
      title={props.title}
      data-item="preview"
      type="button"
      className="panel-block-action btn-link-dark btn btn-link"
      onClick={e => props.onClick(e)}
    >
      <span className={clsx('icon-xs', props.icon)} aria-hidden="true"></span>
      <span className="sr-only">{props.title}</span>
    </button>
  );
};

export default PanelBlockAction;
